export default function AboutPage() {
  return (
    <div className="max-w-4xl mx-auto px-5 lg:px-8 py-20">
      <div className="font-mono-data text-[11px] uppercase tracking-[0.2em] text-[#1E3A8A]">About</div>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-slate-900 mt-3">Verification, without the noise.</h1>
      <div className="mt-8 space-y-6 text-slate-700 leading-relaxed">
        <p>
          The Global Checks is a specialist Background Verification (BGV) firm focused
          exclusively on overseas Address, Litigation and Identity checks. We keep our
          scope deliberately narrow so we can execute each type deeply — with real
          courthouse retrievals, real field agents and real document validations.
        </p>
        <p>
          Our operating hubs in Noida and Bengaluru run parallel case queues for the
          Americas, EMEA and APAC — so a candidate hired anywhere in the world can
          have their check processed within compliant TATs, without hand-offs.
        </p>
        <p>
          We work with HR platforms, RPOs, private investigators and enterprise
          compliance teams. Every case sits inside a per-client portal with statuses,
          remarks and downloadable reports — no email chains, no spreadsheets.
        </p>
      </div>

    </div>
  );
}
